import DOMPurify from 'dompurify';

export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return DOMPurify.sanitize(input, { 
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    ALLOWED_ATTR: ['class', 'id'] 
  });
};

export const validatePhoneNumber = (phone) => {
  const phoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;
  return phoneRegex.test(phone);
};

export const normalizePhoneNumber = (phone) => {
  if (!phone) return phone;
  // Remove all non-digit characters and take the last 10 digits
  const cleaned = String(phone).replace(/\D/g, "");
  return cleaned.slice(-10);
};

/** E.164-style display for read-only UI; does not mutate stored values. */
export const formatPhoneDisplay = (phone) => {
  if (phone == null || phone === "") return "";
  const digits = String(phone).replace(/\D/g, "");
  if (!digits) return "";

  // Always prefer Indian local-number display for UI consistency.
  const localDigits = digits.length >= 10 ? digits.slice(-10) : digits;

  if (localDigits.length === 10) {
    return `🇮🇳 +91 ${localDigits.slice(0, 5)} ${localDigits.slice(5)}`;
  }

  // Partial entry fallback (e.g., while typing): keep prefix fixed and stable.
  return `🇮🇳 +91 ${localDigits}`;
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateFileUpload = (file) => {
  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  const maxSize = 5 * 1024 * 1024; // 5MB
  
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Invalid file type. Only JPEG, PNG, GIF, and WebP are allowed.');
  }
  if (file.size > maxSize) {
    throw new Error('File too large. Maximum size is 5MB.');
  }
  return true;
};

export const sanitizeHTML = (html) => {
  return DOMPurify.sanitize(html, { 
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: [] 
  });
}; 